import type { List } from 'immutable';
import type { BoardSections, RootBoardTypes } from '../../../../common/boards/boardConstants';
import type { IdGraph } from '../../../../common/dataStructures/graphTypes';
import type { ImMNElement, ImMNElementMap } from '../../../../common/elements/elementModelTypes';
import type { PlatformDetails } from '../../../../common/platform/platformTypes';

export type CanvasMenuSelection = {
    kind: 'canvas';
    currentFocus: BoardSections | RootBoardTypes;
    currentBoardId: string;
    elements: ImMNElementMap;
    elementGraph: IdGraph;
    undoCount: number;
    redoCount: number;
};

export type ElementMenuSelection = {
    kind: 'element';
    currentBoardId: string;
    selectedElements: List<ImMNElement>;
};

export type MenuSelection = CanvasMenuSelection | ElementMenuSelection;

export type MenuClipboard = {
    elements: List<ImMNElement>;
};

export type MenuPermissions = {
    canWrite?: boolean;
    showDevTools?: boolean;
};

type MenuContextDependencies = {
    clipboard: MenuClipboard;
    permissions: MenuPermissions;
    platformDetails?: PlatformDetails;
};

export type CanvasMenuContext = CanvasMenuSelection & MenuContextDependencies;
export type ElementMenuContext = ElementMenuSelection & MenuContextDependencies;
export type DerivedMenuContext = CanvasMenuContext | ElementMenuContext;

/** Combines store-free menu inputs without precomputing item-specific visibility flags. */
export function deriveMenuContext(
    selection: CanvasMenuSelection,
    clipboard: MenuClipboard,
    permissions: MenuPermissions,
    platformDetails?: PlatformDetails,
): CanvasMenuContext;
export function deriveMenuContext(
    selection: ElementMenuSelection,
    clipboard: MenuClipboard,
    permissions: MenuPermissions,
    platformDetails?: PlatformDetails,
): ElementMenuContext;
export function deriveMenuContext(
    selection: MenuSelection,
    clipboard: MenuClipboard,
    permissions: MenuPermissions,
    platformDetails?: PlatformDetails,
): DerivedMenuContext {
    return {
        ...selection,
        clipboard,
        permissions,
        platformDetails,
    };
}
